<template>
    <div class="o-dashboardPassword a-mobile">
        <p class="a-price a-price--left a-text--bold a-price--big">
            Zmiana hasła
        </p>
        <o-notifications :is-static="true" name="dashboard-password" />
        <form class="o-form">
            <o-notifications
                :is-static="true"
                name="dashboard-reset-password-1"
            />
            <div class="o-form__buttons o-form__buttons--centered">
                <a-button
                    class="a-button a-button--primary"
                    :is-processing="authStatus === 'pending'"
                    @click="handleSubmit"
                >
                    Rozpocznij proces resetowania hasła
                    <a-icon class="a-button__icon" icon="Right" />
                </a-button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            email: this.getEmail
        }
    },
    computed: {
        ...mapGetters({
            authStatus: 'users/status',
            getEmail: 'users/email'
        })
    },
    methods: {
        handleSubmit() {
            this.$store
                .dispatch('users/resetPasswordStep1', {
                    email: this.getEmail
                })
                .then(response => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: response,
                        limit: 0,
                        name: 'dashboard-reset-password-1'
                    })
                })
                .catch(error => {
                    if (
                        error &&
                        error.response &&
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        this.$store.dispatch('addNotification', {
                            type: 'danger',
                            content: error.response.data.message,
                            limit: 0,
                            name: 'dashboard-login'
                        })
                    }
                })
        }
    },
    mounted() {
        this.$store.dispatch('users/setEmail')
    }
}
</script>
